import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import content, { contentPropTypes } from './FileUploadErrors.content';
import withContent from '../../containers/withContent';
import { getSuccessDataListCount } from '../../utils/benImportUtils';
import { FileUploadRenderContent, CLIENT_SIDE, SERVER_SIDE } from './FileUploadRenderContent';

function FileUploadErrorsComponent({
	content,
	formattedData,
	comparisonChunk = null,
	errorType,
	isServerValidation,
	maxRecordsLimit,
	parserErrorMsg,
}) {
	if (isServerValidation) {
		const successCount = formattedData && getSuccessDataListCount(formattedData);
		const { fullFailureTitle } = content;
		switch (errorType) {
			case 'failure':
				return <span>{fullFailureTitle}</span>;
			default:
				return (
					<FileUploadRenderContent
						content={content}
						formattedData={formattedData}
						comparisonChunk={comparisonChunk}
						errorType={errorType}
						successCount={successCount}
						contentType={SERVER_SIDE}
						parserErrorMsg={parserErrorMsg}
					/>
				);
		}
	}

	return (
		<FileUploadRenderContent
			content={content}
			formattedData={formattedData}
			errorType={errorType}
			contentType={CLIENT_SIDE}
			maxRecordsLimit={maxRecordsLimit}
			parserErrorMsg={parserErrorMsg}
		/>
	);
}

FileUploadErrorsComponent.propTypes = {
	formattedData: PropTypes.arrayOf(PropTypes.object).isRequired,
	comparisonChunk: PropTypes.arrayOf(PropTypes.object),
	errorType: PropTypes.string.isRequired,
	isServerValidation: PropTypes.bool.isRequired,
	maxRecordsLimit: PropTypes.bool,
	content: PropTypes.shape(contentPropTypes).isRequired,
	parserErrorMsg: PropTypes.string.isRequired,
};

export default compose(withContent({ content }))(FileUploadErrorsComponent);
